import { Code, Container } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAbstractMapping, updateAbstractMapping } from "../api";
import { AbstractMappingForm } from "./AbstractMappingForm";
import { notifications } from "@mantine/notifications";

const AbstractMappingEdit = ({ params }) => {
  const { t } = useTranslation("imports");
  const [abstractMapping, setAbstractMapping] = useState(null);

  useEffect(() => {
    getAbstractMapping(params.marketplaceId).then((data) => {
      setAbstractMapping(data);
    });
  }, []);

  if (!abstractMapping)
    return <Container>{t("meta.loadingSchemas")}</Container>;

  return (
    <Container fluid>
      {/* <Code block>{JSON.stringify(abstractMapping, null, 2)}</Code> */}
      <AbstractMappingForm
        marketplaceId={params.marketplaceId}
        initialData={abstractMapping}
        onSubmit={(data) => {
          console.log("data", data);
          updateAbstractMapping(params.marketplaceId, {
            systemFieldMappings: data.predefinedMappings,
            baseCategoryId: data.baseCategoryId,
            mappings: data.customMappings,
            meta: data.metaFields,
            categoryMapper: data.categoryMapper,
            skipRowCount: data.skipRowCount,
          }).then(() => {
            notifications.show({ title: t("abstractMapping.saved") });
          });
          // TBD: Redirect, or reload
        }}
      />
    </Container>
  );
};

export default AbstractMappingEdit;
